import { render, staticRenderFns } from "./reservedNumbers.vue?vue&type=template&id=b0d04dda&scoped=true&"
import script from "./reservedNumbers.vue?vue&type=script&lang=js&"
export * from "./reservedNumbers.vue?vue&type=script&lang=js&"
import style0 from "./reservedNumbers.vue?vue&type=style&index=0&id=b0d04dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d04dda",
  null
  
)

export default component.exports